export enum AllowedGLNavRoutes {
  Insured = '/ucm-forms/gl-insured',
  Owner = '/ucm-forms/gl-owner',
  Ratings = '/ucm-forms/gl-ratings',
  Liability = '/ucm-forms/gl-liability',
  ExcessCoverage = '/ucm-forms/gl-excesscoverage',
  Property = '/ucm-forms/gl-property',
  GeneralQuestion = '/ucm-forms/gl-generalquestion',
  CoverageQuestion = '/ucm-forms/gl-coveragequestion',
  Document = '/general/underwriting/documents',
  RenewalReview = '/ucm-forms/gl-renewalreview',
  Snapshot = '/general/pending-review/policysnapshot',
  PRCoverage = '/general/pending-review/verifycoverage',
  PRPolicy = '/general/pending-review/verifypolicy',
  VPActionItems = '/general/verify-purchase/actionitems',
  VPCoverage = '/general/verify-purchase/coverages',
  VPPolicy = '/general/verify-purchase/policy'
}

export enum AllowedBoundNavRoutes {
  PolicyInfo = '/bound',
  Coverage = '/bound',
  Snapshot = '/bound',
  Declined = '/declined'
}

export enum AllowedGLENInsuredNavRoutes {
  Insured = '/additional/adinsured',
  AddForm = '/additional/addforms',
  Review = '/additional/reviewsubmit'
}

export enum AllowedGLENAddressNavRoutes {
  Address = '/ac-ucm-forms/gl-address-edit',
  Review = '/ac-ucm-forms/gl-address-review'
}

export enum AllowedGLENExposureNavRoutes {
  Payroll = '/ec-ucm-forms/gl-payroll-receipt',
  Review = '/ec-ucm-forms/gl-review-submit'
}

export enum AllowedGLENAClassificationNavRoutes {
  Classification = '/cc-ucm-forms/gl-classification',
  Review = '/cc-ucm-forms/gl-cc-review-submit'
}

export enum AllowedGLENPendingReviewRoutes {
  EnSnapshot = '/pending-review/enpolicysnapshot'
}

export enum GLSubmissionRoutes {
  Step1A = AllowedGLNavRoutes.Insured,
  Step1Address = AllowedGLNavRoutes.Insured,
  Step1AUpdate = AllowedGLNavRoutes.Insured,
  // Step1B = AllowedGLNavRoutes.Owner,
  // Step1BUpdate = AllowedGLNavRoutes.Owner,
  // Step1C = AllowedGLNavRoutes.Ratings,
  // Step1CUpdate = AllowedGLNavRoutes.Ratings,
  Step1B = AllowedGLNavRoutes.Ratings,
  Step1BUpdate = AllowedGLNavRoutes.Ratings,
  Step2A = AllowedGLNavRoutes.Liability,
  Step2AUpdate = AllowedGLNavRoutes.Liability,
  Step2B = AllowedGLNavRoutes.ExcessCoverage,
  Step2BUpdate = AllowedGLNavRoutes.ExcessCoverage,
  Step2C = AllowedGLNavRoutes.Property,
  Step2CUpdate = AllowedGLNavRoutes.Property,
  Step3A = AllowedGLNavRoutes.GeneralQuestion,
  Step3AUpdate = AllowedGLNavRoutes.GeneralQuestion,
  Step3B = AllowedGLNavRoutes.CoverageQuestion,
  Step3BUpdate = AllowedGLNavRoutes.CoverageQuestion,
  Step3C = AllowedGLNavRoutes.Document,
  Step3CUpdate = AllowedGLNavRoutes.Document,
  Renewal = AllowedGLNavRoutes.RenewalReview,
  RenewalReview = AllowedGLNavRoutes.RenewalReview,
  Step4A = AllowedGLNavRoutes.VPActionItems,
  Step4CompForms = AllowedGLNavRoutes.VPActionItems,
  Step4DwnloadDoc = AllowedGLNavRoutes.VPActionItems,
  Step4InstBill = AllowedGLNavRoutes.VPActionItems,
  Step4InstPaid = AllowedGLNavRoutes.VPActionItems,
  Step4InsurForm = AllowedGLNavRoutes.VPActionItems,
  Step4NewTxn = AllowedGLNavRoutes.VPActionItems,
  Step4PremFin = AllowedGLNavRoutes.VPActionItems,
  Step4Purchase = AllowedGLNavRoutes.VPActionItems,
  Step4Update = AllowedGLNavRoutes.VPActionItems,
  EHelpUWReview = AllowedGLNavRoutes.Snapshot,

  Declined = AllowedBoundNavRoutes.Declined,
  'Declined New Business' = AllowedBoundNavRoutes.Declined,
  EHelpReviewDoc = AllowedBoundNavRoutes.Snapshot,
  InspCreated = AllowedBoundNavRoutes.Snapshot,
  InspInfoRequest = AllowedBoundNavRoutes.Snapshot,
  InspReview = AllowedBoundNavRoutes.Snapshot,
  PolicyBound = AllowedBoundNavRoutes.Snapshot,
  Endorsement = AllowedGLENPendingReviewRoutes.EnSnapshot,

  InspCompleted = AllowedBoundNavRoutes.Snapshot,

  StepENAIChange = AllowedGLENInsuredNavRoutes.Insured,
  StepENAIAddForm = AllowedGLENInsuredNavRoutes.AddForm,
  StepENAIReview = AllowedGLENInsuredNavRoutes.Review,
  StepENAddChange = AllowedGLENAddressNavRoutes.Address,
  StepENAddReview = AllowedGLENAddressNavRoutes.Review,
  StepENExpChange = AllowedGLENExposureNavRoutes.Payroll,
  StepEnExpReview = AllowedGLENExposureNavRoutes.Review,
  StepENClassChange = AllowedGLENAClassificationNavRoutes.Classification,
  StepENClassChng = AllowedGLENAClassificationNavRoutes.Classification,
  StepENClassRvw = AllowedGLENAClassificationNavRoutes.Review
}
